import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TabPanel from 'components/TabPanel'
import { Button, DialogConfirm } from 'components'
import { Send } from '@mui/icons-material'

import { put } from 'services/api'
import { cloneDeep } from 'lodash'
import { useSelector } from 'react-redux'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import { toast } from 'react-toastify'
import { MobileStepper } from '@mui/material'

import styles from './styles'
import PageLayout from './MobileLayout'
import { questionsMap } from './questionsMap'

function MobileForm(props) {
  const { dueDiligence, setDueDiligence } = props

  const classes = styles()

  const [formComplete, setFormComplete] = useState(false)

  const form_uuid = useSelector((state) => state.form.uuid)
  const token = useSelector((state) => state.auth.access_token)

  const [activeStep, setActiveStep] = React.useState(0)
  const [completed, setCompleted] = React.useState({})
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [animateNextButton, setAnimateNextButton] = useState(false)

  const steps = [
    'Endereço',
    'Redes sociais',
    'Administração de carteiras',
    'Atividades ambientais',
    'Atividades',
    'Produtos externos',
    'Produtos internacionais',
    'entidades financeiras',
    'Robôs automatizados',
    'parentescos',
    'PEP',
    'Procurações',
    'Investimentos fora da XP',
    'Sanções regulatórias',
    'Ações judiciais',
    'Inquéritos',
    'Mídia negativa',
    'Listas restritivas',
    'Corretoras',
    'Termos de adesão',
  ]

  const totalSteps = () => {
    return steps.length
  }

  const completedSteps = () => {
    return Object.keys(completed).length
  }

  const isLastStep = () => {
    return activeStep === totalSteps() - 1
  }

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps()
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleAnimateNextButton = () => {
    setAnimateNextButton(true)
    setTimeout(() => {
      setAnimateNextButton(false)
    }, 1500)
  }

  const handleComplete = () => {
    const newCompleted = cloneDeep(completed)
    newCompleted[activeStep] = true
    setCompleted(newCompleted)
    if (!isLastStep()) handleAnimateNextButton()
  }

  const updateForm = (newState) => {
    setDueDiligence(newState)
    handleComplete()
  }

  // const handleStep = (step) => () => {
  //   setActiveStep(step)
  // }

  const handleEndForm = () => {
    setOpenConfirmDialog(true)
  }

  const handleCloseConfirm = () => {
    setOpenConfirmDialog(false)
  }

  const handleFinishConfirm = async () => {
    await put({
      url: `/due_diligence/pf/form/finish?form_uuid=${form_uuid}`,
      token,
    })
      .then(() => {
        handleCloseConfirm()
        toast.success(
          'Formulário preechido com sucesso, em breve você será redirecionado à página inicial.',
        )
        gotoUrl(ROUTE_CONSTANTS.DUE_DILIGENCE_RESUME)
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.details ||
            'Houve um erro ao realizar esta ação, por favor, tente novamente',
        )
      })
  }

  const handleNext = () => {
    if (isLastStep()) {
      if (!allStepsCompleted()) {
        // Se for o último passo, mas nem todos os passos estiverem completos,
        // encontra o primeiro passo que não estiver completo
        const nextActiveStep = steps.findIndex((step, i) => !(i in completed))
        setActiveStep(nextActiveStep)
      } else {
        setActiveStep(0)
      }
    } else {
      setActiveStep(activeStep + 1)
    }
  }

  const handleStepsInitialize = () => {
    const stepsCompleted = cloneDeep(completed)
    stepsCompleted['0'] =
      dueDiligence?.address?.has_answer &&
      dueDiligence?.social_networks?.has_answer

    stepsCompleted['1'] =
      dueDiligence.financial_activities.has_answer &&
      dueDiligence.environment_related_activities.has_answer

    stepsCompleted['2'] =
      dueDiligence.external_activities.has_answer &&
      dueDiligence.national_product_offering_activities.has_answer

    stepsCompleted['3'] =
      dueDiligence.international_product_offering_activities.has_answer &&
      dueDiligence.representation_activities.has_answer

    stepsCompleted['4'] =
      dueDiligence.automation_activities && dueDiligence.kinship_xp.has_answer

    stepsCompleted['5'] =
      dueDiligence.pep_relationship &&
      dueDiligence.attorney_activities.has_answer

    stepsCompleted['6'] =
      dueDiligence.third_party_investments.has_answer &&
      dueDiligence.court_lawsuit_cvm_bacen_sfn.has_answer

    stepsCompleted['7'] =
      dueDiligence.environmental_court_lawsuit &&
      dueDiligence.criminal_court_lawsuit.has_answer

    stepsCompleted['8'] =
      dueDiligence.negative_media && dueDiligence.restrictive_list.has_answer

    stepsCompleted['9'] =
      dueDiligence.terms_agreement.has_answer &&
      dueDiligence.relation_with_another_companies.has_answer

    setCompleted(stepsCompleted)
  }

  useEffect(() => {
    const keys = Object.keys(dueDiligence)
    const complete = keys.every((key) => dueDiligence[key].has_answer)
    setFormComplete(complete)
    handleStepsInitialize()
  }, [dueDiligence])

  return (
    <div className={classes.container}>
      <div className={classes.paginationContainer}>
        <Button onClick={handleBack} disabled={activeStep < 1}>
          voltar
        </Button>
        <Button
          disabled={!formComplete}
          color="warning"
          onClick={handleEndForm}
        >
          <span
            style={{
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Enviar &nbsp;&nbsp;{' '}
            <Send
              sx={{ transform: 'rotate(-25deg) translateY(-4px)' }}
              fontSize="small"
            />
          </span>
        </Button>
        <Button
          onClick={handleNext}
          disabled={isLastStep()}
          className={animateNextButton ? classes.nextButtonAnimation : ''}
        >
          avançar
        </Button>
      </div>

      <div className={classes.wrapper}>
        <MobileStepper
          variant="dots"
          steps={steps.length}
          position="static"
          activeStep={activeStep}
          sx={{ maxWidth: '90%', flexGrow: 1 }} 
        />

        {questionsMap.map((question, index) => {
          return (
            <TabPanel key={question.key} value={index} index={activeStep}>
              <PageLayout
                key={question.key}
                formData={dueDiligence}
                updateForm={updateForm}
                Component={question.component}
                questionKey={question.key}
              />
            </TabPanel>
          )
        })}
      </div>

      <DialogConfirm
        open={openConfirmDialog}
        onCancel={handleCloseConfirm}
        onConfirm={handleFinishConfirm}
        title="Tem certeza que deseja finalizar o preenchimento e enviar as respostas do formulário cadastral?"
        btnCancelText="cancelar"
      >
        Ao confirmar a ação, você não poderá mais editar suas respostas. Caso
        deseje revisar alguma das questões, clique em cancelar.
      </DialogConfirm>
    </div>
  )
}

MobileForm.propTypes = {
  dueDiligence: PropTypes.object.isRequired,
}

export default MobileForm
